import { Checkbox } from "primereact/checkbox";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f3f4f6;
  border-radius: 6px;
  margin-bottom: 1rem;
`;

const Description = styled.span`
  color: #6b7280;
  font-size: 12px;
  margin-left: 0.5rem;
`;

/**
 * Form field: isDefault. Renders a checkbox that when checked marks the rule
 * as a Typical rule (no provider/payer). Used inside the provider/payer
 * section of the payer-rule forms; the section itself watches this value and
 * hides the provider/payer inputs when checked.
 *
 * CLE-2524: for template-only rule types the boolean maps to the applicability
 * enum — checked = TYPICAL (inert template), unchecked = SCOPED. Applicability
 * is immutable after create, so edit sections pass `disabled`.
 */
export function IsDefaultCheckbox({ disabled }: { disabled?: boolean }) {
  const { control } = useFormContext<any>();
  return (
    <Controller
      name="isDefault"
      control={control}
      render={({ field: { value, onChange } }) => (
        <Wrapper>
          <Checkbox
            inputId="isDefault"
            checked={!!value}
            disabled={disabled}
            onChange={(e) => onChange(!!e.checked)}
          />
          <label
            htmlFor="isDefault"
            style={{ fontWeight: 600, cursor: "pointer" }}
          >
            Typical rule
          </label>
          <Description>
            Template only — no provider or payer. Has no effect until copied
            into a contract.
          </Description>
        </Wrapper>
      )}
    />
  );
}
